import React, { useState } from 'react';
import { FormControl, OutlinedInput, Select, MenuItem, Box, styled, Divider } from '@mui/material';
import { FieldTypography } from 'StyledTypography/StyledTypography';
import { COLORS } from 'colors/color';
import { useTranslation } from 'react-i18next';

const StyledFormControl = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    height: "40px",
    borderRadius: "8px",
    fontFamily: 'Poppins',
    backgroundColor: '#fff',
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#e0e0e0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#e0e0e0",
    },
  },
});

const CurrencySelect = styled(Select)({
  '& .MuiSelect-select': {
    padding: '6px 10px',
    paddingRight: '1px !important', 
    minWidth: '50px',
    backgroundColor: 'transparent',
    color: COLORS.button_color,
    fontWeight: 'bold',
    fontSize: '14px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiSelect-icon': {
    display: 'none', 
  },
});

const StyledDivider = styled(Divider)({
  height: '24px',
  margin: '0 6px',
  borderColor: '#02006033'
});

// Create a custom input component
const CustomInput = React.forwardRef((props, ref) => (
  <input
    {...props}
    ref={ref}
    style={{
      border: 'none',
      outline: 'none',
      padding: '6px 10px',
      width: '100%',
      fontFamily: 'Poppins',
      fontSize: '14px',
    }}
    type="number"
  />
));

const SalaryInputWithCurrency = ({ salary, setSalary, currency, setCurrency, sx }) => {
  const currencies = [
    { value: 'MAD', label: 'MAD' },
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' },
    { value: 'GBP', label: 'GBP' },
  ];
  const {t} =useTranslation()
  return (
    <Box>
      <FieldTypography sx={{ marginBottom: 1, fontSize: "13px" }}>{t('workingDetailsDialog.salary')}</FieldTypography>
      <StyledFormControl fullWidth sx={sx}>
        <OutlinedInput
          sx={{ padding: 0 }}
          startAdornment={
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: '12px' }}>
              <CurrencySelect
                value={currency}
                onChange={(event) => setCurrency(event.target.value)}
              >
                {currencies.map((option) => (
                  <MenuItem key={option.value} value={option.value} sx={{ fontSize: '14px' }}>
                    {option.label}
                  </MenuItem>
                ))}
              </CurrencySelect>
              <StyledDivider orientation="vertical" />
            </Box>
          }
          inputComponent={CustomInput}
          value={salary}
          onChange={(e) => setSalary(e.target.value)}
          placeholder={t('workingDetailsDialog.enterAmount')}
          inputProps={{
            style: {
              '-webkit-appearance': 'none',
              '-moz-appearance': 'textfield',
            }
          }}
        />
      </StyledFormControl>
    </Box>
  );
};

export default SalaryInputWithCurrency;